import React from 'react'
import { connect } from 'react-redux'
import * as pt from 'prop-types'
import createReactClass from 'create-react-class'
import { Modal } from 'react-bootstrap'
import xtend from 'xtend'
var noop = function () {}

import Snack from '../../common/components/SnackMessage'
import Navigator from '../components/Navigator'
import Settings from '../components/Settings'
import Events from '../components/Events'
import Search from '../components/Search'
import ActiveEvent from '../components/event/ActiveEvent'
import Overlay from '../../common/components/Overlay'
import {
  GET_ENCODERS,
  GET_EVENTS,
  GET_EVENTS_ANALYTICS,
  GET_FULL_EVENT,
} from '../../redux/data/types'
import actions from '../../redux/actions'
import { getHasRequestPending } from '../../redux/data/selectors'
import { EVENT_VIEW_TYPES } from '../../redux/events/reducers'
import EventViewTypeTabs from './EventViewTypeTabs'
import ErrorBoundary from '../../ErrorBoundary'
import TestError from '../../ErrorBoundary/TestError'
import ErrorFallback from '../../ErrorBoundary/ErrorFallback'
import Switch from "react-bootstrap-switch"

var EventsListing = createReactClass({
  propTypes: {
    actions: pt.object.isRequired,
    eventsRequestPending: pt.bool.isRequired,
    events: pt.object.isRequired,
    onActivateEvent: pt.func.isRequired,
    filters: pt.object.isRequired,
    search: pt.object.isRequired, 
    onFilterChange: pt.func.isRequired,
    onSearch: pt.func.isRequired,
    pagination: pt.object.isRequired,
    metadata: pt.object.isRequired,
    onWorkspaceAction: pt.func.isRequired,
    clientID: pt.string.isRequired,
  },

  getInitialState: function () {
    return {
      settingsActive: false,
      overlay: false,
      searchByID: false,
      eventsAnalyticsTimer: null,
    }
  },
  componentDidMount: function () {
    this.props.actions.metadata.keywords.get({})
    this.props.requestEncoders()
    this.props.requestCategories()
  },
  componentDidUpdate: function () {
    var loading = !this.props.eventsLoaded
    if (!this.state.eventsAnalyticsTimer && !loading) {
      const sendRequestEventsAnalytics = () => {
        if (
          !this.props.pendingAnalyticsRequest &&
          this.props.viewType === EVENT_VIEW_TYPES.EXPANDED.key
        ) {
          //request the analytics for all events listed
          const eventIDs = Object.keys(this.props.events)
          this.props.requestEventsAnalytics(eventIDs)
        }
      }
      const timer = setInterval(sendRequestEventsAnalytics, 30000)
      // do initial request
      sendRequestEventsAnalytics()
      this.setState({ eventsAnalyticsTimer: timer })
    }
  },

  handleTechIDFilterChange: function () {
    const { filters, user } = this.props;

    if (filters.techID === user.techID) {
        this.props.onFilterChange({
            type: 'change',
            params: {
                techID: undefined
            }
        });
    } else {
        this.props.onFilterChange({
            type: 'change',
            params: {
                techID: user.techID
            }
        });
    }
  },

  handleSettingsToggle: function () {
    this.setState({
      settingsActive: !this.state.settingsActive,
    })
  },

  handleSettingsChange: function (settings) {
    var params = xtend({}, settings)
    this.props.onFilterChange({
      type: 'change',
      params: params,
    })
  },

  // toggle the overlay
  overlayHook: function (action, opts, cb) {
    cb = cb || noop
    var self = this
    self.setState({ overlay: true })
    self.props.actions.events[action](opts, function () {
      self.setState({ overlay: false })
      cb.apply(null, arguments)
    })
  },

  snackHook: function (action, opts, cb) {
    cb = cb || noop
    var self = this

    var message = {
      add: 'Event Created',
      edit: 'Event Updated',
      delete: 'Event Deleted',
      publish: 'Event Publishing',
      unpublish: 'Event Unpublishing',
      miscAssetToEvent: 'Media Assigned to Event',
    }

    this.props.actions.events[action](opts, function () {
      self.props.onWorkspaceAction({
        type: 'snack',
        snack: {
          type: 'success',
          message: message[action],
        },
      })
      cb.apply(null, arguments)
    })
  },

  assetSnackHook: function (action, opts, cb) {
    cb = cb || noop
    var self = this

    self.props.actions.assets.delete(opts, function () {
      self.props.onWorkspaceAction({
        type: 'snack',
        snack: {
          type: 'success',
          message: 'Asset Deleted',
        },
      })
      cb.apply(null, arguments)
    })
  },

  shouldComponentUpdate: function (nextProps, nextState) {
    return this.props !== nextProps || this.state !== nextState
  },
  componentWillUnmount: function () {
    if (this.state.eventsAnalyticsTimer) {
      clearInterval(this.state.eventsAnalyticsTimer)
    }
  },

  handleSearchParamSelect: function (param) {
    if (param === 'customID' || param === 'eventID') {
      return this.setState({ searchByID: true })
    }
    this.setState({ searchByID: false })
  },

  render: function () {
    var actionsWithSnacks = xtend(this.props.actions, {
      events: xtend(this.props.actions.events, {
        edit: this.snackHook.bind(this, 'edit'),
        delete: this.snackHook.bind(this, 'delete'),
        publish: this.snackHook.bind(this, 'publish'),
        unpublish: this.snackHook.bind(this, 'unpublish'),
        miscAssetToEvent: this.snackHook.bind(this, 'miscAssetToEvent'),
      }),
      assets: xtend(this.props.actions.assets, {
        delete: this.assetSnackHook.bind(this, 'delete'),
      }),
    })

    function navigator(key) {
      return (
        <Navigator
          key={key}
          isTop={key === 'top'}
          eventViewType={this.props.viewType}
          searchComponent={
            key === 'top' ? (
              <Search
                disabled={!this.props.eventsLoaded}
                onParamSelect={this.handleSearchParamSelect}
                onSearch={this.props.onSearch}
                keywords={this.props.metadata.keywords.data}
                lastQuery={this.props.query.search}
              />
            ) : null
          }
          filters={this.props.filters}
          actions={actionsWithSnacks}
          encoders={this.props.encoders}
          onFilterChange={this.props.onFilterChange}
          onQuickFilter={this.props.actions.quickFilter}
          onSettingsToggle={this.handleSettingsToggle}
          pagination={this.props.pagination}
          disabled={!this.props.eventsLoaded}
          socket={this.props.socket}
          dateFiltersDisabled={this.state.searchByID}
        />
      )
    }

    // if (this.props.socket.error) {
    //     return <SocketErrorMessage message="Unable to connect." />;
    // }

    var eventListing
    var loading = !this.props.eventsLoaded
    let activeEvent = this.props.activeEvent
      ? this.props.events[this.props.activeEvent]
      : false
    // if (loading) {
    //     eventListing = <Loader message='Fetching'/>;
    // }
    if (activeEvent) {
      eventListing = (
        <ActiveEvent
          {...this.props}
          key={this.state.activeEvent}
          clientID={this.props.clientID}
          loading={loading}
          actions={actionsWithSnacks}
          event={activeEvent}
          encoders={this.props.encoders}
          transcript={this.props.transcript}
          chat={this.props.chat}
          chatActions={this.props.actions.chat}
          data={this.props.data}
          ga={this.props.ga}
          miscAssets={this.props.miscAssets}
          metadata={this.props.metadata}
          preferences={this.props.preferences}
          pagination={this.state.pagination}
          filters={this.state.filters}
          ajaxState={this.props.eventAjaxState[activeEvent]}
          facebookLiveEvents={this.props.facebookLiveEvents}
          facebookAppID={this.props.facebookAppID}
          emitSnack={this.props.emitSnack}
          toggleActiveEvent={this.props.onActivateEvent}
          onWorkspaceAction={this.props.onWorkspaceAction}
          requests={this.props.requests}
        />
      )
    } else {
      eventListing = (
        <Events
          loading={loading}
          {...this.props}
          requests={this.props.requests}
          chat={this.props.chat}
          onFilterChange={this.props.onFilterChange}
          eventAjaxState={this.props.eventAjaxState}
          encoderActions={this.props.encoderActions}
          chatActions={this.props.actions.chat}
          actions={actionsWithSnacks}
          encoders={this.props.encoders}
          emitSnack={this.props.emitSnack}
          activeEvent={activeEvent}
          events={this.props.events}
          pagination={this.state.pagination}
          filters={this.props.filters}
          search={this.props.search}
          toggleActiveEvent={this.props.onActivateEvent}
          eventID={activeEvent}
        />
      )
    }

    var snack = this.props.error || this.props.message
    var snackExists = !!snack
    snack = snack || {}
    var snackIsError = !!this.props.error

    return (
        <div id="event-listing">
            {this.props.socket.error ? <SocketErrorMessage /> : null}
            <TroubleMessage
                message="Reconnecting…"
                show={this.props.socket.trouble}
            />

            <Overlay active={this.state.overlay} />

            <Snack
                isOpen={snackExists}
                onClose={() => {
                    snack.type === "success" || !snack.type
                        ? this.props.actions.shiftMessage(null)
                        : this.props.actions.shiftError(this.props.error);
                }}
                timeout={snack.type === "success" ? 4000 : null}
                message={
                    snack.type === "success"
                        ? snack.message
                        : this.props.error
                        ? this.props.error.error.message ===
                          "[object ProgressEvent]"
                            ? "Network error"
                            : this.props.error.error.message
                        : ""
                }
                type={snackIsError ? "error" : snack.type || null}
            />

            <Settings
                onChange={this.handleSettingsChange}
                onClose={this.handleSettingsToggle}
                active={this.state.settingsActive}
            />

            <div
                style={{
                    display: "inline-flex",
                    alignItems: "baseline",
                    width: this.props.user.techID ? "100%" : "",
                }}
            >
                {this.props.user.techID ? (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "baseline",
                            width: "100%",
                        }}
                    >
                        <EventViewTypeTabs
                            viewType={this.props.viewType}
                            eventsRequestPending={
                                this.props.eventsRequestPending
                            }
                        />

                        <div style={{ marginLeft: "1.75em" }}>
                            My Assigned Events:{" "}
                            <Switch
                                onChange={this.handleTechIDFilterChange}
                                value={this.props.filters.techID === this.props.user.techID}
                                animate={false}
                            />
                        </div>
                    </div>
                ) : (
                    <EventViewTypeTabs
                        viewType={this.props.viewType}
                        eventsRequestPending={this.props.eventsRequestPending}
                    />
                )}

                {this.props.viewType === EVENT_VIEW_TYPES.EXPANDED.key &&
                !loading ? (
                    <React.Fragment>
                        <div
                            style={{
                                width: "15px",
                                height: "15px",
                                backgroundColor: "yellow",
                                border: "1px solid #7b740e70",
                                zIndex: "0",
                                transform: "rotate(45deg)",
                                marginRight: "-10px",
                                marginTop: "10px",
                                marginBottom: "auto",
                                borderRadius: "4px",
                                paddingRight: "10px",
                            }}
                        >
                            {/*caret el */}
                        </div>
                        <div
                            style={{
                                backgroundColor: "yellow",
                                padding: "0.5em",
                                borderRadius: "7px",
                                zIndex: "1",
                                border: "1px solid #9b892670",
                            }}
                        >
                            Try out the new event listing views
                        </div>
                    </React.Fragment>
                ) : null}
            </div>
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    marginBottom: "1ch",
                }}
            >
                {navigator.call(this, "top")}
            </div>
            <ErrorBoundary FallbackComponent={ErrorFallback}>
                {eventListing}
            </ErrorBoundary>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
                {navigator.call(this, "bottom")}
            </div>
        </div>
    );
  },
})

function TroubleMessage(props) {
  return (
    <Modal bsSize='large' show={props.show}>
      <div
        className='alert alert-warning'
        style={{
          marginBottom: 0,
        }}
      >
        <i className='fa fa-circle-notch fa-spin' aria-hidden='true'></i>
        {' ' + props.message}
      </div>
    </Modal>
  )
}

function SocketErrorMessage(props) {
  return (
    <div className='alert alert-danger'>
      <i className='fa fa-exclamation-triangle' aria-hidden='true'></i>
      <span style={{ marginRight: '1em' }}>
        <div style={{ display: 'inline' }}>
          {' ' + 'Alert!'}
          <hr />
          <p>
            There was a problem connecting to our instant update service.
          </p>
          <p>
            You can Create, Edit, Delete, Start, Stop, Pause, and Publish
            Events; however updates will not show up automatically to all
            applications listening (Control Center users, Players, or embedded
            Listings).
          </p>
          <p>
            <strong>
              Because of this, it's currently required to refresh your browser
              page in order to see changes made by you or other users.
            </strong>
          </p>
          <hr />
          <p>
            Thank you for your patience.
          </p>
        </div>
      </span>
      <a href={window.location.href}>
        <i className='fa fa-refresh'></i> Reload Page
      </a>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  const pendingAnalyticsRequest =
    state.requests &&
    state.requests[GET_EVENTS_ANALYTICS] &&
    state.requests[GET_EVENTS_ANALYTICS].pending
  const viewType = state.events.viewType.key
  const pendingRequestTypes = [GET_EVENTS, GET_ENCODERS]
  if (viewType !== EVENT_VIEW_TYPES.SLIM.key) {
    pendingRequestTypes.push(GET_FULL_EVENT)
  }
  const eventsRequestPending = getHasRequestPending(state, pendingRequestTypes)
  const eventsLoaded = !!(
    ownProps.eventsLoaded &&
    !eventsRequestPending &&
    state.data.encoders
  )
  
  const miscAssetsPending = getHasRequestPending(state, 'BUS/http.assets.getMiscAssets')

  return {
    pendingAnalyticsRequest,
    eventsRequestPending,
    eventsLoaded,
    user: state.data.user,
    viewType,
    miscAssets: {
      ...ownProps.miscAssets,
      isResolving: miscAssetsPending
    }
  }
}

const mapDispatchToProps = (dispatch) => ({
  requestEncoders: () => dispatch(actions.data.requestEncoders()),
  requestCategories: () => {
    dispatch(actions.request.requestCategories())
  },
  requestEventsAnalytics: (eventIDs) =>
    dispatch(actions.data.requestEventAnalytics(eventIDs)),
})

export default connect(mapStateToProps, mapDispatchToProps)(EventsListing)

